import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }

  connect() {
    this.tooltip = null
    this.element.addEventListener("mouseenter", this.show)
    this.element.addEventListener("mouseleave", this.hide)
  }

  disconnect() {
    this.hide()
    this.element.removeEventListener("mouseenter", this.show)
    this.element.removeEventListener("mouseleave", this.hide)
  }

  show = () => {
    if (!this.element.closest("[data-collapsed]")) return
    if (this.tooltip) return

    this.tooltip = document.createElement("div")
    this.tooltip.textContent = this.contentValue
    this.tooltip.className =
      "fixed z-[9999] px-2.5 py-1.5 bg-[#0F2233] text-white text-xs rounded shadow-lg pointer-events-none"
    document.body.appendChild(this.tooltip)

    const rect = this.element.getBoundingClientRect()
    this.tooltip.style.top = `${rect.top + (rect.height - this.tooltip.offsetHeight) / 2}px`
    this.tooltip.style.left = `${rect.right + 8}px`
  }

  hide = () => {
    if (this.tooltip) {
      this.tooltip.remove()
      this.tooltip = null
    }
  }
}
